import { prependParentNode } from './prependParentNode';

export const loadScript = async (src: string, dataAttributes: DOMStringMap = {}, context: Window = window) =>
    prependParentNode<HTMLScriptElement>(
        'script',
        {
            src,
            async: true,
            type: 'text/javascript',
        },
        dataAttributes,
        context
    );
